<template>
  <div>
    <UiTable :data="itemsWithFullLine" :columns="columns" class="ui-curation-view-table" :is-striped="true">
      <template #column-title="{ row }">
        <div class="ui-button-svg-align">
          <UiButtonIcon
            tag="button"
            v-if="editable"
            class="jps-icon-button list-delete"
            @click.stop="emits('delete-item', row)"
            icon="mdi/close-circle"
            icon-size="size-5"
          />
          <BaseLink v-bind="baseLinkProps(row)" @click="emits('show-modal', row)">
            {{ ls(row.title) }}
          </BaseLink>
        </div>
      </template>
      <template #fullline="{ row }">
        <SearchResultDiv :item="row" :editstate="editstate" />
      </template>
      <template #column-db="{ row }">
        <UiDbSpan
          v-if="row.type === 'item' && row.data"
          :id="row.data.common.database"
        />
      </template>
      <template #column-provider="{ row }">
        <template v-if="row.type === 'item' && row.data">
          <UiOrgProviderSpan :id="row.data.common.provider" />
        </template>
        <UiOrgSpan v-else-if="row.ownerOrgId" :id="row.ownerOrgId" />
      </template>
    </UiTable>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
import type { ColumnDef } from '~/components/ui/UiTable.vue'

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
  colList,
} = useCurationListView(props.editstate, props.def)

const itemsWithFullLine = computed(() => {
  return props.items.map((li) => {
    if (li.readNext) li['fullline'] = true
    return li
  })
})

const columns = computed(() => {
  let columns: ColumnDef[] = [
    {
      label: () => ls({ ja: "タイトル", en: "Title" }),
      key: 'title',
      class: 'jps-cl-col-title',
    },
    ...colList.value.map((col) => {
      if (col.type == 'database') {
        return {
          label: () => ls(col.header),
          key: 'db',
        }
      }
      if (col.type === 'provider') {
        return { label: () => ls(col.header), key: 'provider' }
      }
      return {
        label: () => ls(col.header),
        path: ['data.' + col.fields[0]],
      }
    }),
  ]
  return columns
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-button-svg-align {
  display: inline-flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 4px;
}
.ui-curation-view-table {
  :deep(table){
    width: 100%;
    font-size: $size-8;
  }
}

h2 {
  margin: 2rem auto;
}

.list-delete {
  font-size: 1.25rem;
}

table.jps-card-content {
  width: 100%;
  text-align: left;
}

.jps-contributor {
  color: $jps-gray-600;
}

/* テーブル表示 */
@include is-mobile() {
  th.jps-cl-col-title {
    display: none !important;
  }
  td.jps-cl-col-title {
    font-weight: bold !important;
  }
}

.jps-show-more {
  display: flex;
  justify-content: center;
}
.list-add-div {
  text-align: center;
  padding: 0.5rem;
}
</style>
